// The web app's remote-support manager: SupportManager (supportManagerCore.ts) over the data WORKER (REST +
// main socket: data/features/remoteSupport.ts), the calls' synthesized ring (no audio assets), and a silent
// `requireInteraction` notification while the tab is not in front (the ring card is the alert when it is).
import { data } from '../../../bridge/client';
import { t, tf } from '../../../i18n/i18n';
import { mediaUrls } from '../../media';
import { TonePlayer } from '../calls/tones';
import { SupportManager } from './supportManagerCore';

const ringer = new TonePlayer();
let notification: Notification | null = null;

function ring(on: boolean, name: string, userId: string): void {
  notification?.close();
  notification = null;
  if (!on) {
    ringer.stop();
    return;
  }
  ringer.start('ring');
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
  if (document.visibilityState === 'visible' && document.hasFocus()) return;
  try {
    const note = new Notification(t('web.rs.ring.title'), {
      body: tf('web.rs.notification.body', name || '?'),
      icon: userId ? mediaUrls.avatar(userId, 0) : undefined,
      tag: 'satori-remote-support',
      requireInteraction: true,
      silent: true,
    } as NotificationOptions);
    note.onclick = () => {
      window.focus();
      note.close();
    };
    notification = note;
  } catch (error) {
    console.warn('[remote] ring notification', error);
  }
}

export const supportManager = new SupportManager({
  onSignal(listener) {
    data.onSignal((s) => {
      if (s.kind === 'remoteSupport') listener(s.payload);
    });
  },
  activeSession: () => data.call('rsActiveSession'),
  accept: (id) => data.call('rsAccept', id),
  decline: (id) => data.call('rsDecline', id),
  end: (id, reason) => data.call('rsEnd', id, reason),
  signal: (id, payload) => data.call('rsSignal', id, payload),
  markActive: (id) => data.call('rsMarkActive', id),
  iceServers: () => data.call('rsIceServers'),
  ring,
  now: () => Date.now(),
  later: (fn, ms) => {
    const id = setTimeout(fn, ms);
    return () => clearTimeout(id);
  },
  log: (line) => console.info(line),
});

// Test/diagnostic probe (the e2e reads it; no secrets, no input content).
(globalThis as unknown as { __satoriRemoteSupport: () => unknown }).__satoriRemoteSupport = () => ({
  ...supportManager.getState(),
  helper: supportManager.helperSession ? { ...supportManager.helperSession.state, stream: !!supportManager.helperSession.state.stream } : null,
});
